import type { CSSProperties, JSX } from 'react';
import type { Palette } from '../_theme/palette.js';

interface SpinnerProps {
  palette?: Palette;
  size?: number;
  color?: string;
}

// Minimal CSS-only spinner used while a surface is loading. Reads the palette's
// primary accent so it picks up the customer's brand color automatically. The
// keyframe is appended once per shell document.
export function Spinner({ palette, size = 28, color }: SpinnerProps): JSX.Element {
  const accent = color ?? palette?.primary ?? '#6366f1';
  const trackColor = palette?.border ?? 'rgba(15, 23, 42, 0.12)';
  const style: CSSProperties = {
    width: size,
    height: size,
    border: `${Math.max(2, Math.round(size / 12))}px solid ${trackColor}`,
    borderTopColor: accent,
    borderRadius: '50%',
    animation: 'chirp-spin 0.8s linear infinite',
  };
  return <div role="status" aria-label="Loading" style={style} />;
}
